import RichText from '@/components/atoms/rich-text/rich-text';
import Typography from '@/components/atoms/typography/typography';
import CtaLinkList from '@/components/organisms/cta-link-list/cta-link-list';
import Column from '@/components/utilities/column/column';
import Container from '@/components/utilities/container/container';
import ModuleWrapper, {
  ModuleWrapperProps,
} from '@/components/utilities/module-wrapper/module-wrapper';
import Row from '@/components/utilities/row/row';
import ImageScrollOverCard from './image-scroll-over-card/image-scroll-over-card';
import styles from './image-scroll-over.module.scss';

export interface ImageScrollOverProps
  extends Omit<ModuleWrapperProps, 'children'> {
  /** The cards to show */
  cards: Content.Components['ImageScrollOverModuleDto']['cards'];
  /** The text to show as a headline */
  headline?: Content.Components['ImageScrollOverModuleDto']['headline'];
  /** The link to show */
  link?: Content.Components['ImageScrollOverModuleDto']['link'];
  /** The text to show as a description */
  text?: Content.Components['ImageScrollOverModuleDto']['text'];
}

const ImageScrollOver = ({
  cards = [],
  headline,
  link,
  settings,
  text,
  ...rest
}: ImageScrollOverProps) => {
  return (
    <ModuleWrapper {...rest} className={styles.component} settings={settings}>
      <div className={styles.contentWrapper}>
        <Container className={styles.contentContainer}>
          <Row className={styles.contentRow}>
            <Column
              className={styles.content}
              offset={{ desktop: 4, laptop: 2, tablet: 1 }}
              width={{ desktop: 4, laptop: 8, tablet: 10 }}
            >
              {headline && (
                <Typography
                  className={styles.headline}
                  tagStyle="displayMedium"
                >
                  {headline}
                </Typography>
              )}

              {text && <RichText className={styles.text} text={text} />}

              {link && (
                <CtaLinkList items={[{ $type: 'ButtonLinkCtaDto', link }]} />
              )}
            </Column>
          </Row>
        </Container>
      </div>

      <div className={styles.cardsWrapper}>
        <Container>
          <Row>
            {cards[0] && (
              <Column width={{ desktop: 3, laptop: 4, mobile: 6, tablet: 3 }}>
                <div className={styles.firstCard}>
                  <ImageScrollOverCard {...cards[0]} />
                </div>
              </Column>
            )}

            {cards[1] && (
              <Column
                offset={{ laptop: 3, tablet: 1 }}
                width={{ desktop: 3, laptop: 4, mobile: 6, tablet: 3 }}
              >
                <div className={styles.secondCard}>
                  <ImageScrollOverCard {...cards[1]} />
                </div>
              </Column>
            )}

            {cards[2] && (
              <Column
                offset={{ laptop: 1, mobile: 3, tablet: 1 }}
                width={{ desktop: 3, laptop: 4, mobile: 6, tablet: 3 }}
              >
                <div className={styles.thirdCard}>
                  <ImageScrollOverCard {...cards[2]} />
                </div>
              </Column>
            )}

            {cards[3] && (
              <Column
                offset={{ laptop: 3, tablet: 2 }}
                width={{ desktop: 3, laptop: 4, mobile: 6, tablet: 3 }}
              >
                <div className={styles.fourthCard}>
                  <ImageScrollOverCard {...cards[3]} />
                </div>
              </Column>
            )}

            {cards[4] && (
              <Column
                offset={{ laptop: 4, tablet: 2 }}
                width={{ desktop: 3, laptop: 4, mobile: 6, tablet: 3 }}
              >
                <div className={styles.fifthCard}>
                  <ImageScrollOverCard {...cards[4]} />
                </div>
              </Column>
            )}
          </Row>
        </Container>
      </div>
    </ModuleWrapper>
  );
};

ImageScrollOver.displayName = 'ImageScrollOver';

export default ImageScrollOver;
